(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["offer-money"] && !Shopify.designMode) return;
  try {
    // <offer-money> custom HTML Element : converts a store-currency amount to the visitor's currency
  class OfferMoney extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      let cents = parseInt(this.dataset.cents, 10);
      let currency = window.Shopify && window.Shopify.currency;
      if (isNaN(cents) || !currency || !currency.active) return;

      let rate = parseFloat(currency.rate) || 1;
      let converted = Math.round(cents * rate);

      // Reuse the store's money format : the sample is 1234.56 formatted by Liquid (ex. « CHF 1,234.56 »)
      let sample = this.dataset.sample || '';
      let parts = sample.match(/1([^0-9]?)234([^0-9])56/);
      if (parts) {
        let units = Math.floor(converted / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, parts[1]);
        let decimals = String(converted % 100).padStart(2, '0');
        this.textContent = sample.replace(parts[0], units + parts[2] + decimals);
      } else {
        this.textContent = (converted / 100).toFixed(2) + ' ' + currency.active;
      }
    }
  }
  customElements.define('offer-money', OfferMoney);
  } catch(e) { console.error(e); }
})();

})();
